import InputField from 'app/components/forms/inputField';

export default class DateTimeField extends InputField {
  getType() {
    return 'datetime-local';
  }
}



// WEBPACK FOOTER //
// ./app/components/forms/dateTimeField.jsx